import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
    selector: 'app-top-10-records-widget-demo',
    templateUrl: './top-10-records-widget-demo.component.html',
    styleUrl: './top-10-records-widget-demo.component.scss',
    standalone: false
})
export class Top10RecordsWidgetDemoComponent {
  data = [
    { id: 1, rank: 1, email: 'alice@skeddle.com', completionsCount: 42 },
    { id: 2, rank: 2, email: 'bob@skeddle.com', completionsCount: 35 }
  ];

  columns: TableColumn[] = [
    { dataField: 'rank', caption: '#' },
    { dataField: 'email', caption: this.translateService.instant('COMMON.FIELDS.EMAIL') },
    { dataField: 'completionsCount', caption: this.translateService.instant('TOP-10.COUNT-OF-COMPLETIONS-SHORT') }
  ];

  constructor(private translateService: TranslateService){
  }
}
